const config = require('./config')

const getSupportedLanguageCodes = () => {
  return Object.keys(config)
}

const getSupportedLocaleCodes = () => {
  const languages = getSupportedLanguageCodes()
  const supportedLocales = []

  languages.forEach(languageCode => {
    supportedLocales.push(...Object.keys(config[languageCode].supportedLocales))
  })

  return supportedLocales
}

const getSupportedLocaleCodesByLanguage = languageCode => {
  const languageConfig = config[languageCode]

  if (!languageConfig) return []

  return Object.keys(languageConfig.supportedLocales)
}

const getMainLocaleCodes = () => {
  const languages = getSupportedLanguageCodes()

  return languages.map(languageCode => {
    return config[languageCode].mainLocale
  })
}

const getMainLocaleFromLanguage = languageCode => {
  const languageConfig = config[languageCode]

  if (!languageConfig) return null

  return languageConfig.mainLocale
}

const getLanguageCodeByLocale = localeCode => {
  const languages = getSupportedLanguageCodes()

  return languages
    .filter(languageCode => {
      return Object.keys(config[languageCode].supportedLocales).some(
        locale => locale === localeCode
      )
    })
    .pop()
}

const getLocaleName = localeCode => {
  const languageCode = getLanguageCodeByLocale(localeCode)

  if (languageCode) {
    return config[languageCode].languageSpecificNames[languageCode]
  }

  return null
}

const getLocaleSpecificName = (localeCode, targetLocaleCode) => {
  const targetLanguageCode = getLanguageCodeByLocale(targetLocaleCode)
  const languageCode = getLanguageCodeByLocale(localeCode)

  if (!languageCode || !targetLanguageCode) return null

  return config[targetLanguageCode].languageSpecificNames[languageCode]
}

/**
 * Will return a locale that is supported by TicketSwap based on the browser settings.
 * When the browser locale is not supported we default to english instead.
 */
const getBrowserLocale = () => {
  const isBrowser = typeof window !== 'undefined'

  const { language = 'en' } = isBrowser ? navigator : {}

  // If navigator gives back supported locale code, return it
  if (getSupportedLocaleCodes().some(localeCode => localeCode === language)) {
    return language
  }

  /**
   * Sometimes the browser gives the language instead of the locale, for example 'nl' instead of
   * 'nl_NL'. This will try to convert it to the proper locale
   */
  const localeFromLanguage = getMainLocaleFromLanguage(language)

  // Default to english for unsupported locales
  return localeFromLanguage ?? 'en'
}

module.exports = {
  getSupportedLanguageCodes,
  getSupportedLocaleCodes,
  getSupportedLocaleCodesByLanguage,
  getMainLocaleCodes,
  getMainLocaleFromLanguage,
  getLanguageCodeByLocale,
  getLocaleName,
  getLocaleSpecificName,
  getBrowserLocale,
}
